<template>
	<div>
	
		<automation-list @openAutomationCreate="openAutomationCreate" v-if="list_view"></automation-list>
		<automation-create :automation_edit_detail="automation_edit_detail" @openAutomationList="openAutomationList" v-else></automation-create>

	</div>

</template>
<script>

import AutomationCreate from './AutomationCreate'
import AutomationList from './AutomationList.vue'
import automationMixin from './automationMixin'

export default {
	components : {
		AutomationList,
		AutomationCreate
	},
	mixins: [automationMixin],
	data : function(){
		return{
			toggle_model: true,
			list_view: true,
			user_role: this.$store.getters.getRole,
			automation_edit_detail: ''
		}
	},
	created : function(){
	},
	methods:{
		openAutomationCreate(automation_id){
			if(automation_id){
				var params = {
					id: automation_id
				}
				if(this.user_role == 'csm'|| this.user_role == 'admin'){
					params.filters = {
						organization_id : this.id
					}
				}
				this.$store.dispatch('getAutomationByID', params).then((res) => {
					console.log(res.data)
					this.automation_edit_detail = res.data.data
					this.$store.dispatch('updateCurrentActionState', this.automation_edit_detail.raw_rule.actions)

				}).catch((error) => {
					console.log(error);
				});

				
			}

			this.list_view = false
		},
		openAutomationList(){
			this.automation_edit_detail = null
			this.list_view = true
		}
	}
}
</script>
<style src="./automation.css">


</style>


// WEBPACK FOOTER //
// src/components/automation/AutomationDashboard.vue